import { apiGet, apiPost, apiRequest } from "./client";

const API_BASE = process.env.REACT_APP_BACKEND_URL;

export const modelsAdminApi = {
  list: () => apiGet("/api/admin/models"),
  get: (id) => apiGet(`/api/admin/models/${id}`),
  create: (data) => apiPost("/api/admin/models", data),
  update: (id, patch) =>
    apiRequest(`/api/admin/models/${id}`, { method: "PATCH", body: patch }),
  remove: (id) =>
    apiRequest(`/api/admin/models/${id}`, { method: "DELETE" }),
  uploadPhoto: async (id, file) => {
    const fd = new FormData();
    fd.append("file", file);
    const res = await fetch(
      `${API_BASE}/api/admin/models/${id}/photo`,
      { method: "POST", credentials: "include", body: fd },
    );
    if (!res.ok) throw new Error(`Upload failed (${res.status})`);
    return res.json();
  },
  photoUrl: (photoId) =>
    photoId ? `${API_BASE}/api/admin/models/photos/${photoId}` : null,
  removePhoto: (id) =>
    apiRequest(`/api/admin/models/${id}/photo`, { method: "DELETE" }),
  getNote: (targetId) => apiGet(`/api/admin/models/notes/${targetId}`),
  saveNote: (targetId, content) =>
    apiRequest(`/api/admin/models/notes/${targetId}`, {
      method: "PUT",
      body: { content },
    }),
};

export const MODEL_STATUSES = [
  "active",
  "inactive",
  "prospect",
  "external",
  "other",
];
